var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnwavering = function SvgUnwavering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M16.667 30c0-7.364 5.97-13.333 13.333-13.333S43.334 22.636 43.334 30 37.364 43.333 30 43.333H16.667l3.905-3.905A13.3 13.3 0 0 1 16.667 30m6.437 10.667H30A10.666 10.666 0 1 0 19.334 30c0 2.87 1.134 5.553 3.124 7.543l1.885 1.885zM28.667 22h2.667v16h-2.667zm-5.333 4H26v8h-2.666zM34 26h2.667v8H34z"
  })));
};
export default SvgUnwavering;